import { useState } from 'react';

import { localeWidget } from '@lib/tools/locale/source/web/widget';
import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';
import { TCameraFacingMode } from '@components/web/src/templates/Tutorials/ScannerBarcode/ScannerBarcode';
import * as S from '@components/web/src/templates/Tutorials/ScannerBarcode/styles';

interface Props {
  cameraFacingMode: TCameraFacingMode;
  onChange: (mode: TCameraFacingMode) => void;
}

export const CameraModeSwitcher = ({ cameraFacingMode, onChange }: Props) => {
  const { backCameraText, frontCameraText, cameraText } = localeWidget.scanBarcode;

  const CAMERA_LABELS: Record<TCameraFacingMode, ILocaleText> = {
    environment: backCameraText,
    user: frontCameraText,
  };

  const [isOpen, setIsOpen] = useState(false);
  const nextMode: TCameraFacingMode = cameraFacingMode === 'environment' ? 'user' : 'environment';

  const handleToggle = () => setIsOpen(prev => !prev);
  const handleSelect = () => {
    onChange(nextMode);
    setIsOpen(false);
  };

  return (
    <Flexbox align="center" gap={0}>
      <Text color={COLORS.base.black} size="body2" text={cameraText} />
      <S.CameraOptionWrapper>
        <S.SelectedCameraOption align="center" gap={8} padding="9px 8px" onClick={handleToggle}>
          <Text color={COLORS.base.black} size="body2" text={CAMERA_LABELS[cameraFacingMode]} />
          <S.CaretDownIcon $isOpen={isOpen} fillColor={COLORS.base.black} />
        </S.SelectedCameraOption>
        {isOpen && (
          <S.DropdownCameraOption align="center" gap={8} padding="9px 8px" onClick={handleSelect}>
            <Text color={COLORS.base.black} size="body2" text={CAMERA_LABELS[nextMode]} />
          </S.DropdownCameraOption>
        )}
      </S.CameraOptionWrapper>
    </Flexbox>
  );
};
